import React, { Component } from "react"
import QRCode from "qrcode.react"
import config from "react-global-configuration"
import ReceiptBookingProducts from "./receiptBookingProducts"
import * as tracking from "../../helpers/tracking"
import * as endpoints from "../../constants/Endpoints"

class ReceiptBookingInfo extends Component {
  state = {
    isActive: true,
  }

  handlePrintClick = () => {
    tracking.trackParkingFlowClick("print", "reciept", this.props)
    window.open(endpoints.GENERATE_PDF_RECEIPT(this.props.bookingResult.booking.guid, "_blank"))
    // window.print()
  }

  render() {
    const textKeys = config.get("textKeys.receipt.booking") || {}
    if (!this.props.bookingResult) return ""

    const body = textKeys.body || "Vi har modtaget din reservation og sendt en bekræftelse med din QR-kode til {mail}"

    const bodyamend = textKeys.amendBody || "Vi har modtaget dit ønske om ændring af parkeringstidspunkt, en ny ordrebekræftelse sendes til {mail}"
    const bodyExtend =
      textKeys.extendBody ||
      "Du har ændret udkørselstidspunktet for din booking. Du skal bruge din originale QR kode fra din aktive booking til at forlade p-anlægget."

    const { booking, product, extras, carPark, bookingHistory, parking } = this.props.bookingResult
    return (
      <React.Fragment>
        <div className="parking-receipt__top">
          {booking && (booking.barcodeValue || booking.qrCode) ? (
            <div className="receiptQR">
              <QRCode value={booking.barcodeValue || booking.qrCode} size={120} includeMargin={true} />
            </div>
          ) : (
            <figure>
              <img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" />
            </figure>
          )}
          <div>
            <h3>
              {textKeys.header || "Din kvittering"} {booking.reference}
            </h3>

            {/* <h5>{booking.arrivalDate} ({booking.arrivalTime}) - {booking.departureDate} ({booking.departureTime})</h5> */}
            <p>
              {this.props.isAmendment
                ? bodyamend.formatUnicorn({ mail: booking.email })
                : this.props.isExtendedBooking
                  ? bodyExtend.formatUnicorn({ mail: booking.email })
                  : body.formatUnicorn({ mail: booking.email })}
              <br />
              <button className="link" onClick={() => this.handlePrintClick()}>
                {textKeys.print || "Udskriv kvittering"}
              </button>
            </p>
          </div>
        </div>

        <ReceiptBookingProducts
          booking={booking}
          product={product}
          carPark={carPark}
          extras={extras}
          getExtraPrice={this.props.getExtraPrice}
          parking={parking}
          {...this.props}
        />
      </React.Fragment>
    )
  }
}

export default ReceiptBookingInfo
